export const quickFilter = () => {
    const input = document.querySelector("#config-reference-filter");
    const list = document.querySelector("#config-reference-list");
    const names = document.querySelectorAll("#config-reference-list li");
    const namesList = [].slice.call(names);

    if (input) {
        input.addEventListener("keyup", e => {
            let results = namesList.filter(data => data.innerText.toLowerCase().includes(e.target.value.toLowerCase()));
            list.innerHTML = "";
            const filteredHtml = results
                .map(function(item) {
                    return `<li>${item.innerHTML}</li>`;
                })
                .join("");
            list.innerHTML = filteredHtml;
        });
    }
};
